import { ADD_TO_QUOTE } from "../../../actions/sizotsaFuneralCover/quote";
import { SIZOTSA_ROUTING_SET_VALUE } from "../../../actions/sizotsaFuneralCover/routing";
import { quotingRules } from "./quote";
import { routingRules } from "./routing";


export const sizotsaFuneralCoverRules = (store, next, action) => {
  //Personal Details
//   if (action.type.startsWith(PERSONAL_DETAILS_SET_VALID) ){
//         return personalDetailsRules(store, next, action);}
//     // Upload Documents rules
//     if (action.type.startsWith(UPLOAD_DOCUMENTS_SET_VALUE))
//       return uploadDocumentsRules(store, next, action);
//     // Payment detail rules
//     if (action.type.startsWith(PAYMENT_DETAILS_SET_VALUE))
//       return paymentDetailsRules(store, next, action);
//     // Trigger routing transitions
   if (action.type.startsWith(SIZOTSA_ROUTING_SET_VALUE))
        return routingRules(store, next, action);

        if (action.type===ADD_TO_QUOTE) return quotingRules(store, next, action);

  return null;
};
